import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { LOCATION_CHANGE } from 'connected-react-router';
import {
  FILTERS_LOADED_FROM_URL,
  FILTER_CHANGE,
  CLEAR_ALL_FILTERS,
  FILTER_TAG_REMOVED,
  CLEAR_SERVICES_FILTERS_CLICKED,
} from './filtersActionsTypes';
import {
  FILTER_TAG_PATTERNS,
  ARENA_EXPLORE_URL,
} from '../../../utils/constants';
import { locale, location } from '../../../fromWindow';

const clearState = {
  categoryIds: [],
  serviceIds: [],
  clearServiceFlag: false,
  lower: undefined,
  upper: undefined,
  location: undefined,
  lang: [],
};

const initialState = {
  categoryIds: [],
  serviceIds: [],
  clearServiceFlag: false,
  lower: undefined,
  upper: undefined,
  location,
  lang: [locale],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FILTER_CHANGE:
      return {
        ...state,
        ...action.data,
      };
    // if (isEmptyFilters(newState)) {
    //   newState = { ...clearState }
    // }
    // return newState
    case CLEAR_SERVICES_FILTERS_CLICKED:
      return {
        ...state,
        clearServiceFlag: action.isDirty,
      };
    case FILTERS_LOADED_FROM_URL:
      return {
        ...clearState,
        ...action.data,
      };
    case FILTER_TAG_REMOVED: {
      const { tagId } = action;
      let newState = {
        ...state,
      };
      if (tagId === FILTER_TAG_PATTERNS.BUDGET) {
        newState.lower = undefined;
        newState.upper = undefined;
      } else if (tagId === FILTER_TAG_PATTERNS.LOCATION) {
        newState.location = undefined;
      } else if (tagId.includes(FILTER_TAG_PATTERNS.LANGUAGE)) {
        const exclude = tagId.substring(FILTER_TAG_PATTERNS.LANGUAGE.length);
        newState.lang = state.lang.filter(l => l !== exclude);
      } else if (tagId.includes(FILTER_TAG_PATTERNS.SERVICE)) {
        const exclude = tagId.substring(FILTER_TAG_PATTERNS.SERVICE.length);
        newState.serviceIds = state.serviceIds.filter(s => s !== exclude);
      } else if (tagId.includes(FILTER_TAG_PATTERNS.CATEGORY)) {
        const exclude = tagId.substring(FILTER_TAG_PATTERNS.CATEGORY.length);
        newState.categoryIds = state.categoryIds.filter(c => c !== exclude);
      } else {
        throw new Error(`Invalid filter tag id: ${tagId}`);
      }

      if (isEmptyFilters(newState)) {
        newState = { ...clearState };
      }
      return newState;
    }
    case CLEAR_ALL_FILTERS:
      return clearState;
    case LOCATION_CHANGE:
      return _get(action, 'payload.location.pathname') === ARENA_EXPLORE_URL
        ? initialState
        : state;
    default:
      return state;
  }
};

const isEmptyFilters = state =>
  _isEmpty(state.categoryIds) && _isEmpty(state.serviceIds);

export { initialState, clearState, isEmptyFilters };
